module.exports = __webpack_public_path__ + "images/prime_vs_A5_01dd665.png";